import { createdAtAccessor, updatedAtAccessor } from '@pages/User/helpers/columns/shared';
import { createColumnHelper } from '@tanstack/react-table';

import type { TeamRecord } from '../types';

import { getTeamStatus } from './get-team-status';

const columnHelper = createColumnHelper<TeamRecord>();

const statusClasses = {
  Active: 'bg-green-100 text-green-800',
  Disabled: 'bg-red-100 text-red-800',
};

export const getTeamsTableColumns = (onEdit: (team: TeamRecord) => void) => [
  columnHelper.accessor('name', {
    id: 'name',
    header: 'Team name',
    enableColumnFilter: false,
    enableHiding: false,
    sortingFn: 'text',
  }),
  columnHelper.accessor('id', { id: 'id', header: 'ID', enableColumnFilter: false }),
  columnHelper.accessor((team) => getTeamStatus(team), {
    id: 'status',
    header: 'Status',
    enableColumnFilter: false,
    cell: ({ getValue }) => {
      const status = getValue();
      return (
        <span
          className={`inline-flex items-center gap-x-1.5 rounded-xl px-3 py-1 text-xs font-semibold ${statusClasses[status]}`}
        >
          {status}
        </span>
      );
    },
  }),
  createdAtAccessor(columnHelper),
  updatedAtAccessor(columnHelper),
  columnHelper.display({
    id: 'edit',
    header: '',
    enableHiding: false,
    enableColumnFilter: false,
    size: 70,
    minSize: 70,
    maxSize: 70,
    cell: ({ row }) => (
      <button
        type="button"
        className="text-primary-600 hover:text-primary-900 cursor-pointer"
        onClick={() => onEdit(row.original)}
      >
        Edit
      </button>
    ),
    meta: {
      dataCellClassName: 'relative truncate whitespace-nowrap px-1 py-0 text-center text-sm font-medium',
    },
  }),
];
